import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';
import { DatePipe, TitleCasePipe } from '@angular/common';
declare var bootbox:any;
declare var $:any;
@Component({
  selector: 'app-corporate-reports',
  template: require('./corporate-report.component.html')
})
export class CorporateReportComponent extends BaseComponent implements OnInit {



  public progressStatus = "Please wait...";
  public progressTitle = "Progress";
  public progressValue = 0;
  public progressCurrent = 0;
  public progressTotal = 0;

  public showProgress(reset = false) {
    if(reset) {
      this.progressStatus = "Please wait...";
      this.progressTitle = "Progress";
      this.progressValue = 0;
      this.progressCurrent = 0;
      this.progressTotal = 0;
    }
    this.updateProgressValue();
    $("#myProgress").modal("show");
  }

  public updateProgressValue() {
    this.progressValue = Math.round(this.progressCurrent / this.progressTotal * 100);
    if(this.progressValue>100)
      this.progressValue = 100;
    if(this.progressValue<0)
      this.progressValue = 0;
  }

  public hideProgress() {
    $("#myProgress").modal("hide");
    this.busy = null;
    this.applyFilter();
  }

  public startDate = "";
  public endDate = "";

  public optIndex = 1;
  public optValue = "";
  public optYear = "";

  public distributedSurveys = [];
  public organizations = [];

  public selectedOrganization = null;
  public selectedManagerId = -1;

  public managers = [];

  public surveys = [];
  public selectedSurveyId = -1;


  public organizationSelectionChanged() {
    this.selectedManagerId = -1;
    console.log(this.selectedOrganization);
    this.loadOrganizationManagers();
  }


  public loadOrganizationManagers() {
    if(this.selectedOrganization!=null)
      this.managers = this.selectedOrganization.managers;
    else 
      this.managers = [];
  }

  public surveyPercentage(s) {
    var perct = 0;
    perct = s.employeeCompletedCount / s.employeeCount * 100;
    return perct;
  }


  public getSurveySuspendText(survey) {

    if(survey.suspendSurvey == 0 && survey.suspendAnySurvey == 1) {
      return "Few Survey(s) Stopped";
    }
    else if(survey.suspendSurvey==1){
      return "All Survey(s) Stopped";
    }
    else {
      return "";
    }

  }

  public routeParamsUpdated() {
    
  }

  public updateTips(batchNumber) {


    bootbox.confirm({message:"Do you want to update tips from the original survey",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {     

            this.busy = this.lsApi.updateTips(batchNumber).subscribe(resp => {
              if(resp.status) {  
                bootbox.alert(resp.message +"<br><br>" + "<b>Added Tips: </b>" + resp.data[0].added + "<br><b>Missing Tips: </b>"  + resp.data[0].missing + "<br><b>Missing Details: </b><br>" + resp.data[0].missingDetails);
              }
          },
          error => {
              console.log(error);
          });  

        }
      }});

          

  }

  public toggleMasterCheckbox() {
    $(".slave").prop("checked",$(".master").prop("checked"))
  }

  public resendReportEmail(batchNumber) {

    this.busy = this.lsApi.resendReportEmailForBatchNumber(batchNumber).subscribe(resp => {
      if(resp.status) {  
          this.appToast.success(resp.message,"Report Email");
      }
  },
  error => {
      console.log(error);
  });      
  }

  public startEmailSending(batchNumber) {

    this.busy = this.lsApi.queueReportEmailForBatchNumber(batchNumber).subscribe(resp => {
        if(resp.status) {  
            this.appToast.success(resp.message,"Report Email");
        }
    },
    error => {
        console.log(error);
    });      

  }

  public downloadExcel(batchNumber) {
    
  }

  public generateCorporateReport() {
    alert("Corporate report is only available for M3 and M3 Plus survey types");
  }

  public generateM3DepartmentReport() {
    var vals = $(".slave:checked").map(function(){
      return $(this).val();
    }).get();
    if(vals.length<=0) {
      alert("Please select surveys to be included in the report");
      return false;
    }
    var orgId = -1;
    if(this.selectedOrganization != null) {
      orgId = this.selectedOrganization.organizationId;
    }

    this.busy = this.lsApi.generateM3DepartmentReportForBatchNumbers(vals, orgId, this.selectedManagerId, this.selectedSurveyId, this.optYear, this.optIndex, this.optValue).subscribe(resp => {
        if(resp.status) {  
            this.appToast.success("Report Successfully Generated","Report Generated");
            console.log(resp);
            window.location.href = "/resources/survey/report/" + this.lsApp.getCurrentAuthToken() + "/" + resp.data, "_blank";
        }
    },
    error => {
        console.log(error);
    }); 

  }

  public generateM3NewQuestionDepartmentReport() {
    var vals = $(".slave:checked").map(function(){
      return $(this).val();
    }).get();
    if(vals.length<=0) {
      alert("Please select surveys to be included in the report");
      return false;
    }
    var orgId = -1;
    if(this.selectedOrganization != null) {
      orgId = this.selectedOrganization.organizationId;
    }

    this.busy = this.lsApi.generateM3NewQuestionDepartmentReportForBatchNumbers(vals, orgId, this.selectedManagerId, this.selectedSurveyId, this.optYear, this.optIndex, this.optValue).subscribe(resp => {
        if(resp.status) {  
            this.appToast.success("Report Successfully Generated","Report Generated");
            console.log(resp);
            window.location.href = "/resources/survey/report/" + this.lsApp.getCurrentAuthToken() + "/" + resp.data, "_blank";
        }
    },
    error => {
        console.log(error);
    }); 

  }

  public generateM3PlusDepartmentReport() {
    var vals = $(".slave:checked").map(function(){
      return $(this).val();
    }).get();
    if(vals.length<=0) {
      alert("Please select surveys to be included in the report");
      return false;
    }
    var orgId = -1;
    if(this.selectedOrganization != null) {
      orgId = this.selectedOrganization.organizationId;
    }

    this.busy = this.lsApi.generateM3PlusDepartmentReportForBatchNumbers(vals, orgId, this.selectedManagerId, this.selectedSurveyId, this.optYear, this.optIndex, this.optValue).subscribe(resp => {
        if(resp.status) {  
            this.appToast.success("Report Successfully Generated","Report Generated");
            console.log(resp);
            window.location.href = "/resources/survey/report/" + this.lsApp.getCurrentAuthToken() + "/" + resp.data, "_blank";
        }
    },
    error => {
        console.log(error);
    }); 
  }

  public generateM3CorporateReport() {
    var vals = $(".slave:checked").map(function(){
      return $(this).val();
    }).get();
    if(vals.length<=0) {
      alert("Please select surveys to be included in the report");
      return false;
    }
    var orgId = -1;
    if(this.selectedOrganization != null) {
      orgId = this.selectedOrganization.organizationId;
    }

    this.busy = this.lsApi.generateM3CorporateReportForBatchNumbers(vals, orgId, this.selectedManagerId, this.selectedSurveyId, this.optYear, this.optIndex, this.optValue).subscribe(resp => {
        if(resp.status) {  
            this.appToast.success("Report Successfully Generated","Report Generated");
            console.log(resp);
            window.location.href = "/resources/survey/report/" + this.lsApp.getCurrentAuthToken() + "/" + resp.data, "_blank";
        }
    },
    error => {
        console.log(error);
    }); 

    
  }

  public generateM3NewQuestionCorporateReport() {
    var vals = $(".slave:checked").map(function(){
      return $(this).val();
    }).get();
    if(vals.length<=0) {
      alert("Please select surveys to be included in the report");
      return false;
    }
    var orgId = -1;
    if(this.selectedOrganization != null) {
      orgId = this.selectedOrganization.organizationId;
    }

    this.busy = this.lsApi.GenerateM3NewQuestionCorporateReportForBatchNumbers(vals, orgId, this.selectedManagerId, this.selectedSurveyId, this.optYear, this.optIndex, this.optValue).subscribe(resp => {
        if(resp.status) {  
            this.appToast.success("Report Successfully Generated","Report Generated");
            console.log(resp);
            window.location.href = "/resources/survey/report/" + this.lsApp.getCurrentAuthToken() + "/" + resp.data, "_blank";
        }
    },
    error => {
        console.log(error);
    }); 

    
  }

  public generateM3PlusCorporateReport() {
    var vals = $(".slave:checked").map(function(){
      return $(this).val();
    }).get();
    if(vals.length<=0) {
      alert("Please select surveys to be included in the report");
      return false;
    }
    var orgId = -1;
    if(this.selectedOrganization != null) {
      orgId = this.selectedOrganization.organizationId;
    }

    this.busy = this.lsApi.generateM3PlusCorporateReportForBatchNumbers(vals, orgId, this.selectedManagerId, this.selectedSurveyId, this.optYear, this.optIndex, this.optValue).subscribe(resp => {
        if(resp.status) {  
            this.appToast.success("Report Successfully Generated","Report Generated");
            console.log(resp);
            window.location.href = "/resources/survey/report/" + this.lsApp.getCurrentAuthToken() + "/" + resp.data, "_blank";
        }
    },
    error => {
        console.log(error);
    }); 

    
  }

  public viewReport(batchNumber) {

    this.busy = this.lsApi.viewReportForDistributedSurveyBatchNumber(batchNumber).subscribe(resp => {
        if(resp.status) {  
            window.location.href = "/resources/survey/report/" + this.lsApp.getCurrentAuthToken() + "/" + batchNumber + "/" + resp.data[0], "_blank";
        }
    },
    error => {
        console.log(error);
    });  
  }

  public datePipeEn: DatePipe = new DatePipe('en-US')
  public getEmailStats(dSurvey) {
    var lastEmailSent = dSurvey.lastEmailSent;
    if(lastEmailSent == null) {
      return "N/A";
    }
    else {
      var str = "";
      var status = lastEmailSent.mailgunEmailStatues[lastEmailSent.mailgunEmailStatues.length-1];
      var statusDate = this.datePipeEn.transform(status.dateOccured,"dd MMM, yyyy");
      var titleCase = new TitleCasePipe();
      str = titleCase.transform(lastEmailSent.emailType) + "<br>" + titleCase.transform(status.status) + " - <span title='" + this.datePipeEn.transform(status.dateOccured,"dd MMM, yyyy h:mm:ss a z") + "'>" + statusDate + "</span>"

      return str;
    }
  }
  

  public batchCount = 0;
  public applyFilter() {
    console.log("Apply Filter");
    var vals = $(".slave:checked").map(function(){
      return $(this).val();
    }).get();
    var orgId = -1;
    if(this.selectedOrganization != null) {
      orgId = this.selectedOrganization.organizationId;
    }

    this.startDate = $("#dtStart").val();
    this.endDate = $("#dtEnd").val();

    console.log(this.startDate);
    console.log(this.endDate);


    this.busy = this.lsApi.getDistributedSurveysForCorporateReport(orgId, this.selectedManagerId, this.selectedSurveyId, this.optYear, this.optValue, this.optIndex).subscribe(resp => {
        if(resp.status) {
            var data:any = resp.data[0];
            this.batchCount = parseInt(data.batchCount);
            this.distributedSurveys = data.surveys;
            if(vals.length>0) {
              setTimeout(function(){
                vals.forEach(value => {
                  $(".slave[value='" + value + "']").prop("checked",true);
                });
              },0);
            }
        }
    },
    error => {
        console.log(error);
    });
 
  }

  todayDate(addDays = 0) {
    var d = new Date();
    d.setDate(d.getDate() + addDays);
    var month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [day, month, year].join('/');
}

  ngOnInit() {
    super.ngOnInit();
    
    this.optIndex = 1;
    var cMonth = (new Date()).getMonth() + "";
    if(cMonth.length==1)
      cMonth = "0" + cMonth
    this.optValue =  cMonth;
    this.optYear = (new Date()).getFullYear() + "";

    this.startDate = this.todayDate(-120);
    this.endDate = this.todayDate();
    setTimeout(()=>{
      $(".inputmask").inputmask();
    },500);
    this.loadOrganizationsForReportSelect();
    this.getSurveysForSelect();
  }


  public loadOrganizationsForReportSelect() {
    this.busy = this.lsApi.getOrganizationsForReportSelect().subscribe(resp => {
        if(resp.status) {
            this.organizations = resp.data;
        }
    },
    error => {
        console.log(error);
    });
  }


  public getSurveysForSelect() {
    this.lsApi.getSurveysForSelect().subscribe(resp => {
        if(resp.status) {
            this.surveys = resp.data;
        }
    },
    error => {
        console.log(error);
    });
  }



  public stopSurvey(s) {

  }

  public deleteSurvey(s) {

  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/corporate-report/corporate-report.component.ts